// extracted by mini-css-extract-plugin
export var cta = "CallToAction-module--cta--JJwka";
export var wrapper = "CallToAction-module--wrapper--1wMrn";